import type { ComponentProps } from 'react'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import noop from 'lib/function/noop'
import { useTrips } from 'tripPlanner/hooks/api/trip'
import moment from 'moment'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuTripPlannerListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const { data: trips } = useTrips({ onError: noop, onSuccess: noop })
  const upcomingTrips = useMemo(() => trips?.filter((trip) => !trip.endDate || trip.endDate > moment()) || [], [trips])

  const numberOfUpcomingTrips = upcomingTrips.length

  const tripPlansText = intl.formatMessage({
    id: 'PlZDImO9d6',
    defaultMessage: 'Trip Plans',
    description: 'Trip Plans navigation button text in the trip planner feature',
  })

  const upcomingCopy = useMemo(() => {
    if (numberOfUpcomingTrips === 0) {
      return undefined
    }
    return intl.formatMessage(
      {
        id: '10nd9GG9Xa',
        defaultMessage: '{count, plural, one {# upcoming} other {# upcoming}}',
        description: 'Number of upcoming trips count in the trip planner feature',
      },
      { count: numberOfUpcomingTrips },
    )
  }, [intl, numberOfUpcomingTrips])

  return <NavBarListItem
    {...props}
    startIcon={<NavBarListItemIcon Icon={LineHeartIcon} colour="primary" />}
    title={tripPlansText}
    endTitle={upcomingCopy}
    to="/trip-planner"
  />
}

export default AccountMenuTripPlannerListItem
